'use client'

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'

import { trackSitePageView } from '@/lib/analytics/site-client'
import { normaliseTrackedPath } from '@/lib/analytics/site-paths'

/**
 * Cookieless page-view beacon for the public site. App routes are skipped
 * here; the server allow-list is still the check that decides what is stored.
 * `lastPath` only advances on a tracked page, so the first public page of a
 * load is the entrance even if the session started inside the product.
 */
export function SitePageViewTracker() {
  const pathname = usePathname()
  const lastPath = useRef<string | null>(null)

  useEffect(() => {
    if (!pathname) return
    const tracked = normaliseTrackedPath(pathname)
    if (!tracked || tracked === lastPath.current) return
    trackSitePageView({ path: tracked, entrance: lastPath.current === null })
    lastPath.current = tracked
  }, [pathname])

  return null
}
